module.exports = __webpack_public_path__ + "static/ActivateShop-9c450de67bce02ebb34d5b40c310a463.png";